import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import DspContextualTargetsMgmt from './components/DspContextualTargetsMgmt';

export default function DspContextualTargetsPage() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Amazon DSP Contextual Targets</h3>
        </Col>
      </Row>
      <Row>
        <DspContextualTargetsMgmt />
      </Row>
    </Container>
  );
}
